import * as Yup from "yup";

const BrandCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  code: Yup.string()
    .matches(/^[0-9]$/, "Code must be a single digit between 0 and 9")
    .required("Code is required"),
});
export default BrandCreationSchema;
